export default {
      id: "chevron-up-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#chevron-up",
      toString: function () {
        return this.url;
      }
    }